import { render, staticRenderFns } from "./SelectPayment.vue?vue&type=template&id=0ec20655&scoped=true&"
import script from "./SelectPayment.vue?vue&type=script&lang=js&"
export * from "./SelectPayment.vue?vue&type=script&lang=js&"
import style0 from "./SelectPayment.vue?vue&type=style&index=0&id=0ec20655&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec20655",
  null
  
)

export default component.exports